export default __webpack_public_path__ + "static/media/mus-pruneyoutalkfunny.e7431b40.mp4";